import { Ty, Relation, RelVar } from '@cotera/era';
import _ from 'lodash';

export class GraphRef {
  rel: Relation;
  relVar: RelVar;
  assumptions: Record<string, Ty.ExtendedAttributeType>;

  constructor(
    readonly name: string,
    assumptions: Record<string, Ty.Shorthand>
  ) {
    this.assumptions = _.mapValues(assumptions, (x) => Ty.ty(x));

    this.relVar = RelVar.create({
      name,
      scope: '@@cotera-graph-refs',
      ty: this.assumptions,
    });

    this.rel = this.relVar;
  }
}
